/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Displays user profiles
***************************************************************/
import { PROFILE_URLS } from '../constants';
import Tabs from '../components/tabs';
import { fetchAllEmployees } from '../actions/profile_actions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';


class Profile extends Component {
  componentDidMount() {
    if (this.props.employees.length === 0) return this.props.fetchAllEmployees(this.props.user.level, this.props.user.email, this.props.user.guid);
    document.title = 'Profile';
  }
  render() {
    return (
      <div>
        <div className="row">
          <h5>Profile <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
          <Tabs id={"profile"} tabs={PROFILE_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    employees: state.profile.employees
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllEmployees
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Profile);



/* END */



// WEBPACK FOOTER //
// ./src/containers/profile.js